import easyfyAxios from '@shared/easyfy.axios';

export const GetLoginFlyout = async (): Promise<any> => {
  return await easyfyAxios.get('/api/loginflyout');
};
